const SubscribePage = ({ id }) => {
  return (
    <section
      id={id}
      className="h-3/4 py-5 flex flex-col items-center justify-center bg-midnight "
    >
      <div className="w-full lg:w-3/4 grid grid-cols-1 md:grid-cols-2 bg-midnight">
        <div className="flex flex-col items-center justify-center p-3 md:p-0">
          <img
            src="/logo-vertical.png"
            alt="Logo"
            className="object-cover h-40"
          />
        </div>
        <div className="h-full flex flex-col justify-center items-center p-4 md:p-0">
          <div className="flex flex-col gap-3 text-center md:text-left">
            <p className="text-xl text-white">Contact Us</p>
            <p className="text-gray-400">
              1319 F St NW, Ste 301
              <br /> Washington, DC 20004
            </p>
            <p className="text-gray-400">Email: info@colorizon.us</p>
            <p className="text-gray-400">Phone: +1-202-607-2913</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubscribePage;
